module.exports = __webpack_public_path__ + "media/images/country_flags/cf-c024745f3c51eddf847b05c3d42e86ae.png";